import HalfScreen from './HalfScreen';
import HalfScreenResponsive from './HalfScreenResponsive';

export default HalfScreen;
